import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import 'react';
import { CarouselList } from './CarouselList.js';
import { OneColList } from './OneColList.js';
import { ThreeColList } from './ThreeColList.js';
import { TwoColList } from './TwoColList.js';
import { jsx } from '@emotion/react';

var _excluded = ["colType"];
function Exhibitions(_ref) {
  var colType = _ref.colType,
    others = _objectWithoutProperties(_ref, _excluded);
  var renderList = function renderList() {
    switch (colType) {
      case 1:
        return jsx(OneColList, others);
      case 2:
        return jsx(TwoColList, others);
      case 3:
        return jsx(ThreeColList, others);
      case 'carousel':
        return jsx(CarouselList, others);
      default:
        return jsx(OneColList, others);
    }
  };
  return jsx(Wrapper, null, renderList());
}
var Wrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1n2v2ei0"
} : {
  target: "e1n2v2ei0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4QzBCIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCdWNrZXRMb2dEYXRhIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2J1Y2tldC1sb2cnO1xuXG5pbXBvcnQgeyBCYWRnZVR5cGUgfSBmcm9tICcuLi9FeGhpYml0aW9uUHJvZHVjdENhcmQvVGV4dEJhZGdlL3R5cGVzJztcbmltcG9ydCB7IENhcm91c2VsTGlzdCB9IGZyb20gJy4vQ2Fyb3VzZWxMaXN0JztcbmltcG9ydCB7IE9uZUNvbExpc3QgfSBmcm9tICcuL09uZUNvbExpc3QnO1xuaW1wb3J0IHsgVGhyZWVDb2xMaXN0IH0gZnJvbSAnLi9UaHJlZUNvbExpc3QnO1xuaW1wb3J0IHsgVHdvQ29sTGlzdCB9IGZyb20gJy4vVHdvQ29sTGlzdCc7XG5pbXBvcnQgeyBDb2xUeXBlLCBFeGhpYml0aW9uSXRlbSB9IGZyb20gJy4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIEV4aGliaXRpb25zUHJvcHMge1xuICBzdG9yZUl0ZW1MaXN0OiBFeGhpYml0aW9uSXRlbVtdO1xuICBjb2xUeXBlOiBDb2xUeXBlO1xuICBiYWRnZVR5cGU6ICdub25lJyB8IEJhZGdlVHlwZTtcbiAgdXNlQnV5QnV0dG9uPzogYm9vbGVhbjtcbiAgbG9nRGF0YT86IEJ1Y2tldExvZ0RhdGE7XG4gIGV4cGVyaW1lbnRUeXBlPzogc3RyaW5nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gRXhoaWJpdGlvbnMoe1xuICBjb2xUeXBlLFxuICAuLi5vdGhlcnNcbn06IEV4aGliaXRpb25zUHJvcHMpOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCByZW5kZXJMaXN0ID0gKCk6IFJlYWN0RWxlbWVudCA9PiB7XG4gICAgc3dpdGNoIChjb2xUeXBlKSB7XG4gICAgICBjYXNlIDE6XG4gICAgICAgIHJldHVybiA8T25lQ29sTGlzdCB7Li4ub3RoZXJzfSAvPjtcbiAgICAgIGNhc2UgMjpcbiAgICAgICAgcmV0dXJuIDxUd29Db2xMaXN0IHsuLi5vdGhlcnN9IC8+O1xuICAgICAgY2FzZSAzOlxuICAgICAgICByZXR1cm4gPFRocmVlQ29sTGlzdCB7Li4ub3RoZXJzfSAvPjtcbiAgICAgIGNhc2UgJ2Nhcm91c2VsJzpcbiAgICAgICAgcmV0dXJuIDxDYXJvdXNlbExpc3Qgey4uLm90aGVyc30gLz47XG4gICAgICBkZWZhdWx0OlxuICAgICAgICByZXR1cm4gPE9uZUNvbExpc3Qgey4uLm90aGVyc30gLz47XG4gICAgfVxuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPFdyYXBwZXI+XG4gICAgICB7IHJlbmRlckxpc3QoKSB9XG4gICAgPC9XcmFwcGVyPlxuICApO1xufVxuXG5jb25zdCBXcmFwcGVyID0gc3R5bGVkLmRpdmBgO1xuIl19 */");

export { Exhibitions };
//# sourceMappingURL=index.js.map
